import axios from 'axios'

const regex = /\(([^)]+)\)/

export default {

  viewSource(projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/deployments/latest`)
  },

  applyChanges(projectId) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/deployments/latest`)
  },


  prove(projectId, option, facts, limit) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/queries/latest`,
      {
        elements: facts,
        options: [ { id: option }],
        limit: limit
      })
  },

  getVariables(prologExpression) {
    const match = prologExpression.match(regex)
    if (match) {
      const variables = match[1].split(',').map(v => v.trim())
      return variables
    }
    return []
  },

  decorateVariables(prologExpression) {
    const variables = this.getVariables(prologExpression).map(v => '{' + v.trim() + '}').join(', ')
    if(variables.length > 0) {
      return prologExpression.replace(regex, `(${variables})`)
    }
    return prologExpression
  },

  formatUnicorn(str, argsObject) {
    var t = typeof argsObject;
    var key;
    var args = ("string" === t || "number" === t) ?
        Array.prototype.slice.call(argsObject)
        : argsObject;
    for (key in args) {
        str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
    }
    return str;
  },

  escapeProlog(prolog) {
    if (prolog.match(/^[A-Z]/)) {
      return `'${prolog}'`
    }
    return prolog
  },

  toQueryElement(element) {
    let params = []
    for (const [key, value] of Object.entries(element.variables)) {
      params.push({
        name: key,
        value: value
      })
    }
    return {
      id: element.id,
      parameters: params
    }
  },

  evaluate(prologExpression, variables) {
    let escapedVariables = {}
    for (const [key, value] of Object.entries(variables)) {
      escapedVariables[key] = this.escapeProlog(value)
    }
    return this.formatUnicorn(prologExpression, escapedVariables)
  },

  addVariableSupport(element) {
    if(element.variables) {
      return element
    }
    return Object.assign({}, element, {
      prologVariabilized: this.decorateVariables(element.prolog),
      variables: this.getVariables(element.prolog).reduce((obj, variable) => {
        obj[variable] = ''
        return obj
      }, {})
    })
  },

  addVariableSupportForAllElements(elements) {
    return elements.map(element => this.addVariableSupport(element))
  },

  compareResultByErrorThenByHasSolutionThenByName(result1, result2)  {
    if( result1.error && !result2.error ) {
      return 1
    }
    else if( !result1.error && result2.error ) {
      return -1
    }
    if( result1.response?.hasSolutions && !result2.response?.hasSolutions ) {
      return -1
    }
    else if( !result1.response?.hasSolutions && result2.response?.hasSolutions ) {
      return 1
    }
    return result1.option.name.localeCompare(result2.option)
  },

  sortResultByErrorThenByHasSolutionThenByName(results) {
    return results.sort((a, b) => this.compareResultByErrorThenByHasSolutionThenByName(a, b))
  },

}